(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rath-newsletter"]) return;
  try {
    
(() => {
  const panel = document.getElementById('RathNewsletter');
  if (!panel) return;
  const preview = window.Shopify?.theme?.role === 'unpublished' && new URLSearchParams(location.search).get('rath_newsletter_preview') === '1';
  if (panel.dataset.enabled !== 'true' && !preview) return;
  const prefix = 'rath_newsletter_';
  const day = 86400000;
  const read = (key, session = false) => {
    try { const value = (session ? sessionStorage : localStorage).getItem(prefix + key); if (value) return value; } catch {}
    const match = document.cookie.split('; ').find(value => value.startsWith(prefix + key + '='));
    return match ? decodeURIComponent(match.slice(match.indexOf('=') + 1)) : '';
  };
  const write = (key, value, days) => {
    try { (days ? localStorage : sessionStorage).setItem(prefix + key, String(value)); } catch {}
    document.cookie = `${prefix}${key}=${encodeURIComponent(value)}; Path=/; SameSite=Lax; Secure${days ? `; Max-Age=${days * 86400}` : ''}`;
  };
  const onCartPage = /\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname);
  let cartBlocked = onCartPage || Number(panel.dataset.cartCount) > 0 || read('cart', true) === '1';
  let shown = read('shown', true) === '1';
  let engaged = false;
  let elapsed = false;
  let timer;
  let observer;
  let previousFocus;
  const close = (dismissed) => {
    const restoreFocus = panel.contains(document.activeElement);
    panel.hidden = true;
    if (restoreFocus && previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus();
    if (dismissed) write('dismissed_until', Date.now() + 30 * day, 30);
  };
  const blockForCart = () => {
    cartBlocked = true;
    write('cart', '1');
    clearTimeout(timer);
    close(false);
  };
  const cartSelector = 'cart-drawer-component dialog[open], .cart-drawer__dialog[open]';
  const canShow = () => !cartBlocked && !document.hidden && !document.querySelector(cartSelector) && !document.querySelector('dialog[open]') && !document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  const attempt = () => {
    if (!elapsed || !engaged || shown || !canShow()) return;
    if (panel.dataset.subscriber === 'true' || read('subscribed') === '1' || Number(read('dismissed_until')) > Date.now()) return;
    shown = true;
    write('shown', '1');
    previousFocus = document.activeElement;
    panel.hidden = false;
  };
  panel.querySelector('[data-newsletter-close]').addEventListener('click', () => close(true));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) close(true); });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-testid="cart-drawer-trigger"], cart-drawer-component, form[action*="/cart/add"] button, button[name="add"], [name="checkout"], a[href*="/cart"], a[href*="/checkout"]')) blockForCart();
  }, true);
  document.addEventListener('submit', event => {
    if (event.target instanceof HTMLFormElement && /\/cart(?:\/|$)/.test(new URL(event.target.action, location.origin).pathname)) blockForCart();
  }, true);
  document.addEventListener('cart:update', blockForCart);
  document.addEventListener('quantity-selector:update', blockForCart);
  observer = new MutationObserver(() => { if (document.querySelector(cartSelector)) blockForCart(); });
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], childList: true });
  window.addEventListener('pagehide', () => { clearTimeout(timer); observer.disconnect(); });
  if (panel.querySelector('[data-newsletter-success]')) {
    write('subscribed', '1', 365);
    if (canShow()) panel.hidden = false;
    return;
  }
  if (panel.querySelector('[data-newsletter-errors]')) { if (canShow()) panel.hidden = false; return; }
  if (cartBlocked) { blockForCart(); return; }
  if (preview) { previousFocus = document.activeElement; panel.hidden = false; return; }
  const scrollCheck = () => {
    const travel = document.documentElement.scrollHeight - window.innerHeight;
    if (travel > 0 && window.scrollY / travel >= 0.5) engaged = true;
    attempt();
  };
  window.addEventListener('scroll', scrollCheck, { passive: true });
  document.addEventListener('mouseout', event => { if (!event.relatedTarget && event.clientY <= 0 && elapsed) { engaged = true; attempt(); } });
  document.addEventListener('visibilitychange', attempt);
  document.addEventListener('focusout', () => setTimeout(attempt, 0));
  timer = setTimeout(() => { elapsed = true; scrollCheck(); }, 30000);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], childList: true });
    if (read('cart', true) === '1' || document.querySelector(cartSelector)) { blockForCart(); return; }
    if (!shown) timer = setTimeout(() => { elapsed = true; scrollCheck(); }, 30000);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
